export function GlobeIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1_205)" className={className}>
        <path d="M1.66669 10H18.3334M1.66669 10C1.66669 14.6024 5.39765 18.3334 10 18.3334M1.66669 10C1.66669 5.39765 5.39765 1.66669 10 1.66669M18.3334 10C18.3334 14.6024 14.6024 18.3334 10 18.3334M18.3334 10C18.3334 5.39765 14.6024 1.66669 10 1.66669M10 1.66669C12.0844 3.94865 13.269 6.91005 13.3334 10C13.269 13.09 12.0844 16.0514 10 18.3334M10 1.66669C7.91562 3.94865 6.73106 6.91005 6.66669 10C6.73106 13.09 7.91562 16.0514 10 18.3334" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1_205">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

GlobeIcon.displayName = 'GlobeIcon';
